// src/features/meeting/meetingslice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMeetings,
  addMeeting,
  updateMeeting,
  deleteMeeting,
} from "./meetingApi";

// Thunks
export const fetchMeetings = createAsyncThunk(
  "meetings/fetchmeetings",
  async (paramsOptions, thunkAPI) => {
    const response = await getMeetings(paramsOptions);
    return { data: response.data, pagination: response.pagination };
  }
);

export const createMeeting = createAsyncThunk(
  "meetings/createmeeting",
  async (meetingData) => {
    const formmeetingData = new FormData();
    Object.entries(meetingData).forEach(([key, value]) => {
      if (value) formmeetingData.append(key, value);
    });
    const response = await addMeeting(meetingData);
    return response;
  }
);

export const updateMeetingData = createAsyncThunk(
  "meetings/updatemeeting",
  async (meetingData) => {
    const response = await updateMeeting(meetingData);
    return response;
  }
);

export const deleteMeetingById = createAsyncThunk(
  "meetings/deletemeeting",
  async (id) => {
    const response = await deleteMeeting(id);
    return response;
  }
);

const meetingslice = createSlice({
  name: "meetings",
  initialState: {
    meetings: [],
    pagination: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMeetings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMeetings.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.meetings = data;
        state.pagination = pagination;
      })
      .addCase(createMeeting.fulfilled, (state, action) => {
        state.meetings.push(action.payload.data);
      })
      .addCase(updateMeetingData.fulfilled, (state, action) => {
        const idx = state.meetings.findIndex((u) => u.id === action.payload.id);
        if (idx !== -1) {
          state.meetings[idx] = action.payload.data;
        }
      })
      .addCase(deleteMeetingById.fulfilled, (state, action) => {
        state.meetings = state.meetings.filter(
          (u) => u.id !== action.payload.id
        );
      });
  },
});

export default meetingslice.reducer;
